import { createQuery } from "react-query-kit";
import type { AxiosResponse } from "axios";

import type {
  IJoinVideoVisit,
  IJoinVideoVisitParams,
} from "@api/videoVisit/types";
import type { IApiResponse, IAxiosFn } from "@/api";
import { axiosClient, AxiosError } from "@/api";

const key = "join-video-visit";

type IResponse = AxiosResponse<IApiResponse<IJoinVideoVisit>>;
type IVariables = IJoinVideoVisitParams;

export const joinVideoVisit: IAxiosFn<IVariables, IResponse> = async (
  params,
  signal,
) => {
  return axiosClient.get("/appointments/join-video-visit", {
    params,
    signal,
  });
};

export const useJoinVideoVisit = createQuery<IResponse, IVariables, AxiosError>(
  {
    primaryKey: key,
    queryFn: ({ queryKey: [_primaryKey, variables], signal }) =>
      joinVideoVisit(variables, signal),
    retry(_failureCount, error) {
      return error.code !== AxiosError.ERR_BAD_REQUEST;
    },
  },
);
